import { lazy } from "react";

// project imports
import { RoleLevel } from "../../../domain/entities/Role";
import MainLayout from "../theme/layout/MainLayout";
import Loadable from "../theme/widgets/Loadable";
import { ProtectedRoute } from "./util/ProtectedRoute";

// dashboard routing
const MyDocuments = Loadable(
  lazy(() => import("../pages/signatory/MyDocuments"))
);
const DocumentViewer = Loadable(
  lazy(() => import("../pages/signatory/DocumentViewer"))
);
const DocumentSigner = Loadable(
  lazy(() => import("../pages/signatory/DocumentSigner"))
);
const NewInvoice = Loadable(
  lazy(() => import("../pages/signatory/invoices/NewInvoice"))
);
const ExternalChat = Loadable(
  lazy(() => import("../pages/signatory/external-chat-communication/"))
);

// ==============================|| MAIN ROUTING ||============================== //

const SignatoryRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    { path: "mydocuments", element: <MyDocuments /> },
    {
      path: "view_",
      element: (
        <ProtectedRoute>
          <DocumentViewer />
        </ProtectedRoute>
      ),
    },
    { path: "view", element: (
      <ProtectedRoute level={ RoleLevel.Signatory }>
        <DocumentViewer />
      </ProtectedRoute>
      ), 
    },
    { path: "sign", element:(
      <ProtectedRoute level={ RoleLevel.Signatory }>
        <DocumentSigner />
      </ProtectedRoute>
      ), 
    },
    {
      path: "new-invoice",
      element: <NewInvoice />,
    },
    {
      path: "new-invoice",
      element: <NewInvoice />,
    },
    {
      path: "chat", element:(
      <ProtectedRoute level={ RoleLevel.Signatory }>
        <ExternalChat />
      </ProtectedRoute>
      ),
    },
  ],
};

export default SignatoryRoutes;
